import { render, staticRenderFns } from "./AvatarStoreItemModal.vue?vue&type=template&id=09f99dee&"
import script from "./AvatarStoreItemModal.vue?vue&type=script&lang=js&"
export * from "./AvatarStoreItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports